module.exports = __webpack_public_path__ + "static/img/1518081694625686171.045942c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/1518081694625686171.jpg
// module id = GbpC
// module chunks = 0